module.exports = __webpack_public_path__ + "img/e42.3eb9c397.png";